import {NotificationManager} from 'react-notifications';

export const errorHandler = (message, title = "") => {
    NotificationManager.error(message, title, 4000);
}